"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Rws = /*#__PURE__*/function () {
  function Rws(robonomics) {
    _classCallCheck(this, Rws);

    this.robonomics = robonomics;
    this.subscription = false;
  } // consts


  _createClass(Rws, [{
    key: "getAuctionCost",
    value: function getAuctionCost() {
      return this.robonomics.api.consts.rws.auctionCost;
    }
  }, {
    key: "getMinimalBid",
    value: function getMinimalBid() {
      return this.robonomics.api.consts.rws.minimalBid;
    } // queries

  }, {
    key: "getAuctionQueue",
    value: function () {
      var _getAuctionQueue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.robonomics.api.query.rws.auctionQueue();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAuctionQueue() {
        return _getAuctionQueue.apply(this, arguments);
      }

      return getAuctionQueue;
    }()
  }, {
    key: "getUnspendBondValue",
    value: function () {
      var _getUnspendBondValue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.robonomics.api.query.rws.unspendBondValue();

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUnspendBondValue() {
        return _getUnspendBondValue.apply(this, arguments);
      }

      return getUnspendBondValue;
    }()
  }, {
    key: "getAuction",
    value: function () {
      var _getAuction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(index) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.robonomics.api.query.rws.auction(index);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAuction(_x) {
        return _getAuction.apply(this, arguments);
      }

      return getAuction;
    }()
  }, {
    key: "getLedger",
    value: function () {
      var _getLedger = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(account) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.robonomics.api.query.rws.ledger(account);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getLedger(_x2) {
        return _getLedger.apply(this, arguments);
      }

      return getLedger;
    }()
  }, {
    key: "getDevices",
    value: function () {
      var _getDevices = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(account) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.robonomics.api.query.rws.devices(account);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDevices(_x3) {
        return _getDevices.apply(this, arguments);
      }

      return getDevices;
    }() // extrinsics

  }, {
    key: "bid",
    value: function bid(index, amount) {
      return this.robonomics.api.tx.rws.bid(index, amount);
    }
  }, {
    key: "setDevices",
    value: function setDevices(devices) {
      return this.robonomics.api.tx.rws.setDevices(devices);
    }
  }, {
    key: "call",
    value: function call(subscription, tx) {
      return this.robonomics.api.tx.rws.call(subscription, tx);
    } // helpers

  }, {
    key: "getFreeAuctions",
    value: function () {
      var _getFreeAuctions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var auctions, auctionQueue, _iterator, _step, index, auction;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                auctions = [];
                _context6.next = 3;
                return this.getAuctionQueue();

              case 3:
                auctionQueue = _context6.sent;
                _iterator = _createForOfIteratorHelper(auctionQueue);
                _context6.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 15;
                  break;
                }

                index = _step.value;
                _context6.next = 11;
                return this.getAuction(index);

              case 11:
                auction = _context6.sent;

                if (auction.value.winner.isNone) {
                  auctions.push(index.toNumber());
                }

              case 13:
                _context6.next = 7;
                break;

              case 15:
                _context6.next = 20;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6["catch"](5);

                _iterator.e(_context6.t0);

              case 20:
                _context6.prev = 20;

                _iterator.f();

                return _context6.finish(20);

              case 23:
                return _context6.abrupt("return", auctions);

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 17, 20, 23]]);
      }));

      function getFreeAuctions() {
        return _getFreeAuctions.apply(this, arguments);
      }

      return getFreeAuctions;
    }()
  }, {
    key: "getFirtsFreeAuction",
    value: function () {
      var _getFirtsFreeAuction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var auctionQueue, _iterator2, _step2, index, auction;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getAuctionQueue();

              case 2:
                auctionQueue = _context7.sent;
                _iterator2 = _createForOfIteratorHelper(auctionQueue);
                _context7.prev = 4;

                _iterator2.s();

              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context7.next = 15;
                  break;
                }

                index = _step2.value;
                _context7.next = 10;
                return this.getAuction(index);

              case 10:
                auction = _context7.sent;

                if (!auction.value.winner.isNone) {
                  _context7.next = 13;
                  break;
                }

                return _context7.abrupt("return", index.toNumber());

              case 13:
                _context7.next = 6;
                break;

              case 15:
                _context7.next = 20;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](4);

                _iterator2.e(_context7.t0);

              case 20:
                _context7.prev = 20;

                _iterator2.f();

                return _context7.finish(20);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 17, 20, 23]]);
      }));

      function getFirtsFreeAuction() {
        return _getFirtsFreeAuction.apply(this, arguments);
      }

      return getFirtsFreeAuction;
    }()
  }, {
    key: "isSubscription",
    value: function () {
      var _isSubscription = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(address) {
        var ledger;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getLedger(address);

              case 2:
                ledger = _context8.sent;
                return _context8.abrupt("return", !ledger.isNone);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function isSubscription(_x4) {
        return _isSubscription.apply(this, arguments);
      }

      return isSubscription;
    }()
  }]);

  return Rws;
}();

exports["default"] = Rws;